import { Component, OnInit, Input } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from '@angular/common/http';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { UserAdminEditComponent } from './user-admin-edit/user-admin-edit.component';

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';

import { faFile, faFileCsv, faFileDownload,faFileExcel,faFileCode } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-user-admin',
  templateUrl: './user-admin.component.html',
  styleUrls: ['./user-admin.component.scss']
})
export class UserAdminComponent implements OnInit {
  
  
  tableDef = {
    title:"User",
    tableName:"users",
    pagedOn:true,
    filterOn:true,
    sortOn:true,
    fields:[
      { name: "id",
        label: "Id",
        type: "string",
        width: "40px",
        readonly : true
      },
      { name: "username",
        label: "User Name",
        type: "string",
        required: true,
        unique: true
      },
      { name: "fullname",
        label: "Full Name",
        type: "string",
        align: "left"
      },
      { name: "initials",
        label: "Initials",
        type: "string",
        width: "60px"
      },
      { name: "usertype",
        label: "User Type",
        type: "dropdown",
        required: true,
        default:"Regular",
        values: ["Admin","Regular","None"],
        width: "80px"                    
      },
      { name: "userrole",
      label: "User Role",
      type: "string",
      required: false,
      width: "80px"
      },
      { name: "logincount",
        label: "Login Count",
        type: "integer",
        align: "right",
        width: "60px",
        readonly : true
      },
      { name: "lastlogin",
        label: "Last Login",
        type: "datetime",
        align: "center",
        width: "80px",
        readonly : true
      },
      { name: "created",
      label: "Created",
      type: "datetime",
      align: "center",
      width: "80px",
      readonly : true
    },{ name: "createdby",
    label: "Created By",
    type: "string",
    align: "center",
    width: "80px",
    readonly : true
  },
    ],
    form:[
      ['id'],
      ['username'],
      ['fullname','initials'],
      ['usertype','userrole']
    ]
  }


  isData:boolean = true;
  
  data = [];
  loading = false;
  selectedRow = null;


  constructor(private http: HttpClient,
    public dialog: MatDialog,
    library: FaIconLibrary,
    ) { 
      library.addIcons(faFileDownload,faFileExcel,faFileCsv,faFile,faFileCode);
    }

  ngOnInit(): void {


    // initialise
    this.loading = false;
    this.data = [];
        
    // get the data ...
    this.loadData();


  }

  loadData() {
    
    this.loading = true;

    this.http.get("/api/data/" + this.tableDef.tableName).subscribe(
      (response: any) => {
        const rtn = response;
        this.loading = false;
        this.data = response
        
      }, (error: any) => {
        // window.location.href = "/login"
        console.log('unable to get data');
        console.log(error);
      }
    );
  }

  updateData(data){
    
    this.loading = true;

    // console.log(JSON.stringify(data));

    // --- update the user first
    let body = new HttpParams();
    Object.keys(data.user).forEach(x => {
      body = body.append(x,data.user[x]);
    })

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    this.http.post("/api/data/" + this.tableDef.tableName, body.toString(), {headers: headers})
    .subscribe(
      (response: any) => {

        if(response.success){
          // update the data if the id is already there, or add if its not
          // is returned as an array with a single row

          const rtnid = response["id"];
          const rtndata = response["data"][0];

          let found = false;
          this.data.forEach((x,i) => {
            if(x["id"]==rtnid){
              found = true;
              this.data[i] = rtndata;
            }
          });

          if(!found) this.data.push(rtndata);
        
          // ok now update the useraccess - if there is any
          if(data.useraccess.length>0){
              // add in the userid - incase it is new
              data.useraccess.forEach(x => {
                  x["userid"] = rtnid
              })

              const headers = new HttpHeaders().set('Content-Type', 'application/json');
              this.http.post("/api/data/useraccess", data.useraccess, {headers: headers})
              .subscribe(
                (response: any) => {
          
                  if(response.success){
                    this.loading = false;        
                  }
          
                }, (error: any) => {
                  console.log('Unable to update the user access list');
                  this.loading = false; 
                }
              );          
              
          }

          this.loading = false;

        }

      }, (error: any) => {
        console.log('Unable to update the table');
        alert("Sorry - the username already exist")
        this.loading = false;
      }
    );
  }

  deleteData(data){

    // turn the data object into form data to post
    let body = new HttpParams().append("id",data["id"]);
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    const options = {
      headers:headers,
      body: body
    }

    this.http.delete("/api/data/" + this.tableDef.tableName, options)
    .subscribe(
      (response: any) => {

        if(response.success){
          // get the id of the deleted row and remove that from the data
          const rtnid = response["id"];                  
          this.data = this.data.filter(x => (x["id"]!=rtnid));
              
        }

        // this.entities$.next(response);
        //console.log(response);
      }, (error: any) => {
        console.log('Unable to delete from the table');
      }
    );

  }

  export(){

  }

  selectRow(id){
    this.selectedRow = id;
  }

  addTable(){
    this.openTableEdit({});
  }

  editTable(id){
    // find the data row and pass to the edit    
    this.selectedRow = id;
    const d = this.data.filter(x => (x.id == this.selectedRow))
    if(d.length==1) this.openTableEdit(d[0]);    
  }

  openTableEdit(data){

    let newdata = this.deepCopy(data);

    let tableEdit = {
      tableDef: this.tableDef,
      data: newdata,
      allData: this.data
    }
    
    let dialogRef = this.dialog.open(UserAdminEditComponent, {
      height: '650px',
      width: '720px',
      data: tableEdit      
    });

    dialogRef.afterClosed().subscribe(result => {

      if(result=="cancel"){

      } else if(result=="delete"){

        // delete from the database
        this.deleteData(newdata)

      } else if(result!=undefined){

        // save to the database
        this.updateData(result)
        
      }
    })  
  }

    // deep copy of Object
    private deepCopy(obj) {
      return Object.keys(obj).reduce((v, d) => Object.assign(v, {
        [d]: obj[d]== null ? null : (obj[d].constructor === Object) ? this.deepCopy(obj[d]) : obj[d]
      }), {});
    }
  
    private deepCopyArray(arr){
      let narray = [];
      arr.forEach(el => {
        narray.push(this.deepCopy(el))
      });
      return narray
    }

}

